
import { Vue, Component } from 'vue-property-decorator'
import TextEditor from '@/components/base/TextEditor.vue'
import Subelement from '@/types/subelement'

@Component({
  components: { TextEditor }
})

export default class SubelementShowDetailsTab extends Vue {
  settings = {
    routeNames: { list: 'subelements', show: 'subelementShow', edit: 'subelementEdit' },
    routeParamKey: 'subelementId',
    functionNames: { setCurrent: 'setCurrentSubelement', save: 'saveSubelement' },
    getterNames: { current: 'currentSubelement', loading: 'loadingSubelement', errors: 'subelementErrors' }
  }

  get currentItem () : Subelement {
    return this.$store.getters[this.settings.getterNames.current]
  }

  get errors () : { [key:string]: string[] } {
    return this.$store.getters[this.settings.getterNames.errors]
  }

  get loading () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].item
  }

  get saving () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].save
  }
}
